<template>
  <div v-if="computedBikeparkBridgesVisibility">
    <v-dialog
      v-model="computedBikeparkBridgesVisibility"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card>
          <v-btn icon @click="methodToggleListView('bikepark', 'bridges')">
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title class="hidden-sm-and-down"
            >Bike Park Bridges</v-toolbar-title
          >
          <v-spacer class="hidden-sm-and-down"></v-spacer>
          <v-btn @click="addBridge = true" color="info">Add Bridge</v-btn>
          <v-spacer class="hidden-sm-and-down"></v-spacer>
          <v-text-field
            append-icon="search"
            single-line
            hide-details
            v-model="search"
            placeholder="Filter data"
            style="margin-bottom: 15px;"
          ></v-text-field>
          <v-spacer class="hidden-sm-and-down" />
          <v-menu
            bottom
            left
            v-if="
              computedAuthProfile === 'admin' ||
                computedAuthProfile === 'maintenance'
            "
          >
            <v-btn slot="activator" icon>
              <v-icon>get_app</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click.stop="methodDownloadCSVAll()">
                <v-list-tile-title>All</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click.stop="methodDownloadCSVOne()">
                <v-list-tile-title>1 only</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="methodDownloadCSVOneAndTwo()">
                <v-list-tile-title>1 or 2</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                @click="
                  methodDownloadKML(
                    $store.state.mapLayers.bikepark.layers.bridges.geojson,
                    'trail_name',
                    'bikepark_bridges.kml'
                  )
                "
              >
                <v-list-tile-title>KML</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar>
        <div
          style="
            background-color: black;
            padding-left: 30px;
            overflow: auto;
            -webkit-overflow-scrolling: touch;
          "
        >
          <v-data-table
            :headers="headers"
            :items="computedBikeparkBridgesGeoJsonFeatures"
            :rows-per-page-items="rows_per_page"
            :rows-per-page-text="rows_per_page_text"
            :search="search"
            class="elevation-1"
            :loading="computedBikeparkBridgesLoading"
          >
            <template slot="items" slot-scope="props">
              <tr
                @click="
                  methodToggleSingleLayer(
                    'bikepark',
                    'bridges',
                    true,
                    props.item.properties.id
                  )
                "
              >
                <td>{{ props.item.properties.zone }}</td>
                <td>{{ props.item.properties.trail_name }}</td>
                <td>{{ props.item.properties.bridge_num }}</td>
                <td>{{ props.item.properties.dt_inspect }}</td>
                <td>{{ props.item.properties.inspector }}</td>
                <td>{{ props.item.properties.dt_blt }}</td>
                <td>{{ props.item.properties.max_load }}</td>
                <td>{{ props.item.properties.foundation }}</td>
                <td>{{ props.item.properties.cribbing }}</td>
                <td>{{ props.item.properties.sills }}</td>
                <td>{{ props.item.properties.s_wood_typ }}</td>
                <td>{{ props.item.properties.stringers }}</td>
                <td>{{ props.item.properties.st_wood_ty }}</td>
                <td>{{ props.item.properties.railings }}</td>
                <td>{{ props.item.properties.decking }}</td>
                <td>{{ props.item.properties.need_v_sig }}</td>
                <td>{{ props.item.properties.need_num_s }}</td>
                <td>{{ props.item.properties.notes }}</td>
              </tr>
            </template>

            <!-- Alert when no results found -->
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
              >Your search for "{{ search }}" found no results.</v-alert
            >
          </v-data-table>
        </div>
        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>

    <!-- ADD BRIDGE DIALOG -->
    <v-dialog
      v-model="addBridge"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card>
          <v-btn
            icon
            @click="
              addBridge = false;
              clearWatchLocation();
              lat = null;
              lng = null;
              accuracy = null;
              altitude = null;
              form = null;
              base64image = null;
            "
          >
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title class="hidden-sm-and-down"
            >Add Bridge</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn
            v-if="!tracking"
            :disabled="tracking"
            color="success"
            @click="geoWatchPosition()"
            >Start GPS</v-btn
          >
          <v-btn
            v-if="tracking"
            :disabled="!tracking"
            color="error"
            @click="clearWatchLocation()"
            >Stop GPS</v-btn
          >
          <v-spacer></v-spacer>
        </v-toolbar>
        <div
          style="
            background-color: black;
            padding-left: 30px;
            overflow: auto;
            -webkit-overflow-scrolling: touch;
          "
        >
          <v-data-table
            v-if="addBridge"
            :items="addItemBlank"
            :hide-headers="addItemHideHeaders"
            :hide-actions="addItemHideActions"
          >
            <template slot="items">
              <tr>
                <td>Image</td>
                <td>
                  <image-uploader
                    @input="setOutput"
                    :quality="0.7"
                    :autoRotate="attemptAutoRotate"
                    outputFormat="base64"
                    class="fileinput2"
                    :preview="true"
                    accept=".jpg, .jpeg"
                    :key="attemptAutoRotate"
                  ></image-uploader>
                </td>
              </tr>
              <tr>
                <td>EXIF rotate?</td>
                <td><v-checkbox v-model="attemptAutoRotate" class="mt-2" /></td>
              </tr>
              <tr>
                <td>Latitude</td>
                <td>
                  <span v-if="!lat && tracking">Getting latitude...</span>
                  {{ lat }}
                </td>
              </tr>
              <tr>
                <td>Longitude</td>
                <td>
                  <span v-if="!lng && tracking">Getting longitude...</span>
                  {{ lng }}
                </td>
              </tr>
              <tr>
                <td>Accuracy</td>
                <td>
                  <span v-if="!accuracy && tracking">Getting accuracy...</span>
                  {{ accuracy }}
                  <span v-if="accuracy">m</span>
                </td>
              </tr>
              <tr>
                <td>Altitude</td>
                <td>
                  <span v-if="!altitude && tracking">Getting altitude...</span>
                  {{ altitude }}
                  <span v-if="altitude">m</span>
                </td>
              </tr>
              <tr>
                <td>Zone</td>
                <td>
                  <v-select
                    ref="ref_zone"
                    v-model="form.zone"
                    :items="opt_zone"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Trail Name</td>
                <td>
                  <v-autocomplete
                    ref="ref_trail_name"
                    v-model="form.trail_name"
                    :items="computedUniqueTrailNames"
                  ></v-autocomplete>
                </td>
              </tr>
              <tr>
                <td>Bridge Number</td>
                <td>
                  <v-text-field
                    ref="ref_bridge_num"
                    v-model="form.bridge_num"
                  />
                </td>
              </tr>
              <tr>
                <td>Date Inspected</td>
                <td>
                  <v-menu
                    ref="menu_dt_inspect"
                    v-model="menu_dt_inspect"
                    close-on-content-click
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        ref="ref_dt_inspect"
                        v-model="form.dt_inspect"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.dt_inspect"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_dt_inspect = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_dt_inspect.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </td>
              </tr>
              <tr>
                <td>Inspected by</td>
                <td>
                  <v-text-field ref="ref_inspector" v-model="form.inspector" />
                </td>
              </tr>
              <tr>
                <td>Date Built</td>
                <td>
                  <v-menu
                    ref="menu_dt_blt"
                    close-on-content-click
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        ref="ref_dt_blt"
                        v-model="form.dt_blt"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="form.dt_blt" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu_dt_blt = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_dt_blt.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </td>
              </tr>
              <tr>
                <td>Max Load</td>
                <td>
                  <v-select
                    ref="ref_max_load"
                    v-model="form.max_load"
                    :items="opt_max_load"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Foundation</td>
                <td>
                  <v-select
                    ref="ref_foundation"
                    v-model="form.foundation"
                    :items="opt_1to5"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Cribbing</td>
                <td>
                  <v-select
                    ref="ref_cribbing"
                    v-model="form.cribbing"
                    :items="opt_1to5"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Sills</td>
                <td>
                  <v-select
                    ref="ref_sills"
                    v-model="form.sills"
                    :items="opt_1to5"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Sills Wood Type</td>
                <td>
                  <v-select
                    ref="ref_s_wood_typ"
                    v-model="form.s_wood_typ"
                    :items="opt_s_wood_typ"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Stringers</td>
                <td>
                  <v-select
                    ref="ref_stringers"
                    v-model="form.stringers"
                    :items="opt_1to5"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Stringer Wood Type</td>
                <td>
                  <v-select
                    ref="ref_st_wood_ty"
                    v-model="form.st_wood_ty"
                    :items="opt_s_wood_typ"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Railings</td>
                <td>
                  <v-select
                    ref="ref_railings"
                    v-model="form.railings"
                    :items="opt_1to5"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Decking</td>
                <td>
                  <v-select
                    ref="ref_decking"
                    v-model="form.decking"
                    :items="opt_1to5"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Need Vehicle Sign?</td>
                <td>
                  <v-select
                    ref="ref_need_v_sig"
                    v-model="form.need_v_sig"
                    :items="opt_yes_no"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Need Bridge # Sign?</td>
                <td>
                  <v-select
                    ref="ref_need_num_s"
                    v-model="form.need_num_s"
                    :items="opt_yes_no"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Notes</td>
                <td>
                  <v-textarea ref="ref_notes" v-model="form.notes"></v-textarea>
                </td>
              </tr>
            </template>
            <template slot="footer">
              <tr>
                <td colspan="100%">
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                  <v-btn
                    @click.stop="
                      methodAddBikeparkBridgesGeoJson({
                        lat: lat,
                        lng: lng,
                        accuracy: accuracy,
                        altitude: altitude,
                        zone: form.zone,
                        trail_name: form.trail_name,
                        bridge_num: form.bridge_num,
                        dt_inspect: form.dt_inspect,
                        inspector: form.inspector,
                        dt_blt: form.dt_blt,
                        max_load: form.max_load,
                        foundation: form.foundation,
                        cribbing: form.cribbing,
                        sills: form.sills,
                        s_wood_typ: form.s_wood_typ,
                        stringers: form.stringers,
                        st_wood_ty: form.st_wood_ty,
                        railings: form.railings,
                        decking: form.decking,
                        need_v_sig: form.need_v_sig,
                        need_num_s: form.need_num_s,
                        notes: form.notes,
                        modified: pgDate(Date.now()),
                        base64data: base64image
                      });
                      addBridge = false;
                      clearWatchLocation();
                      lat = null;
                      lng = null;
                      accuracy = null;
                      altitude = null;
                    "
                    color="success"
                    >Save</v-btn
                  >
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<style>
.fileinput2 {
  color: green;
}
</style>
<script>
("dataBikeparkBridges");
import { parse } from "json2csv";

export default {
  data() {
    return {
      attemptAutoRotate: false,
      form: {
        zone: null,
        trail_name: null,
        bridge_num: null,
        dt_inspect: null,
        inspector: null,
        dt_blt: null,
        max_load: null,
        foundation: null,
        cribbing: null,
        sills: null,
        s_wood_typ: null,
        stringers: null,
        st_wood_ty: null,
        railings: null,
        decking: null,
        need_v_sig: null,
        need_num_s: null,
        notes: null
      },
      date: null,
      base64image: null,
      lat: null,
      lng: null,
      accuracy: null,
      altitude: null,
      addItemBlank: [""],
      addItemHideHeaders: true,
      addItemHideActions: true,
      watchId: null,
      tracking: false,
      addBridge: false,
      loading: true,
      search: "",
      rows_per_page: [
        10,
        25,
        50,
        {
          text: "All",
          value: -1
        }
      ],
      rows_per_page_text: "Per page:",
      headers: [
        {
          text: "Zone",
          value: "properties.zone"
        },
        {
          text: "Trail Name",
          value: "properties.trail_name"
        },
        {
          text: "Bridge Number",
          value: "properties.bridge_num"
        },
        {
          text: "Date Inspected",
          value: "properties.dt_inspect"
        },
        {
          text: "Inspector",
          value: "properties.inspector"
        },
        {
          text: "Date Built",
          value: "properties.dt_blt"
        },
        {
          text: "Max Load",
          value: "properties.max_load"
        },
        {
          text: "Foundation",
          value: "properties.foundation"
        },
        {
          text: "Cribbing",
          value: "properties.cribbing"
        },
        {
          text: "Sills",
          value: "properties.sills"
        },
        {
          text: "Sills Wood Type",
          value: "properties.s_wood_typ"
        },
        {
          text: "Stringers",
          value: "properties.stringers"
        },
        {
          text: "Stringers Wood Type",
          value: "properties.st_wood_ty"
        },
        {
          text: "Railing",
          value: "properties.railing"
        },
        {
          text: "Decking",
          value: "properties.decking"
        },
        {
          text: "Needs Vehicle Sign",
          value: "properties.need_v_sig"
        },
        {
          text: "Needs Number Sign",
          value: "properties.need_num_s"
        },
        {
          text: "Notes",
          value: "properties.notes"
        }
      ],
      opt_zone: [
        { text: "Creekside" },
        { text: "Fitzsimmons" },
        { text: "Garbanzo" },
        { text: "Peak" }
      ],
      opt_max_load: [
        { text: "Bike" },
        { text: "UTV" },
        { text: "Heavy Machinery" }
      ],
      opt_1to5: [
        { text: 1 },
        { text: 2 },
        { text: 3 },
        { text: 4 },
        { text: 5 }
      ],
      opt_s_wood_typ: [
        { text: "Cedar" },
        { text: "Balsam" },
        { text: "Fir" },
        { text: "Hemlock" },
        { text: "Other" }
      ],
      opt_yes_no: [{ text: "Yes" }, { text: "No" }],
      opt_csv: [{ text: "All" }, { text: "1 only" }, { text: "1 and 2" }],
      menu_dt_blt: false,
      menu_dt_inspect: false
    };
  },
  computed: {
    computedUniqueTrailNames() {
      const trailNames = this.$store.state.mapLayers.bikepark.layers.bridges
        .geojson.features;

      let a = []; // blank array
      for (let i = 0; i < trailNames.length; i++) {
        a.push(trailNames[i].properties.trail_name); // push all trails into array a
      }

      return a.unique().sort(); // returns sorted unique trail names
    },
    computedUniqueLocations() {
      const locations = this.$store.state.mapLayers.bikepark.layers.bridges
        .geojson.features;

      let a = []; // blank array
      for (let i = 0; i < locations.length; i++) {
        if (locations[i].properties.sign_loc !== null) {
          a.push(locations[i].properties.sign_loc); // push all sign locations into array a
        }
      }
      return a.unique().sort(); // returns sorted unique sign locations
    },
    computedBikeparkBridgesGeoJsonFeatures() {
      if (
        this.$store.state.mapLayers.bikepark.layers.bridges.geojson.features
      ) {
        const bridges = this.$store.state.mapLayers.bikepark.layers.bridges
          .geojson.features;

        let hideHidden = bridges.filter(item => item.properties.hidden != "t");
        return hideHidden;
      }
      return [];
    },
    computedBikeparkBridgesVisibility() {
      return this.$store.state.mapLayers.bikepark.layers.bridges.visibility
        .listView;
    },
    computedBikeparkBridgesLoading() {
      return this.$store.state.mapLayers.bikepark.layers.bridges.loading;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedAuth() {
      return this.$store.state.auth;
    }
  },
  methods: {
    methodDownloadCSVAll() {
      const fields = [
        {
          label: "Zone",
          value: "properties.zone"
        },
        {
          label: "Trail Name",
          value: "properties.trail_name"
        },
        {
          label: "Bridge Number",
          value: "properties.bridge_num"
        },
        {
          label: "Date Inspected",
          value: "properties.dt_inspect"
        },
        {
          label: "Inspector",
          value: "properties.inspector"
        },
        {
          label: "Date Built",
          value: "properties.dt_blt"
        },
        {
          label: "Max Load",
          value: "properties.max_load"
        },
        {
          label: "Foundation",
          value: "properties.foundation"
        },
        {
          label: "Cribbing",
          value: "properties.cribbing"
        },
        {
          label: "Sills",
          value: "properties.sills"
        },
        {
          label: "Sills Wood Type",
          value: "properties.s_wood_typ"
        },
        {
          label: "Stringers",
          value: "properties.stringers"
        },
        {
          label: "Stringers Wood Type",
          value: "properties.st_wood_ty"
        },
        {
          label: "Railing",
          value: "properties.railing"
        },
        {
          label: "Decking",
          value: "properties.decking"
        },
        {
          label: "Needs Vehicle Sign",
          value: "properties.need_v_sig"
        },
        {
          label: "Needs Number Sign",
          value: "properties.need_num_s"
        },
        {
          label: "Notes",
          value: "properties.notes"
        }
      ];
      const opts = { fields };

      try {
        const csv = parse(
          this.$store.state.mapLayers.bikepark.layers.bridges.geojson.features.sort(
            (a, b) => {
              if (a.properties.trail_name < b.properties.trail_name) return -1;
              if (a.properties.trail_name > b.properties.trail_name) return 1;
              return 0;
            }
          ),
          opts
        );
        const blob = new Blob([csv], { type: "octet/stream" });
        const a = document.createElement("a");
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = "bikepark_bridges_all.csv";
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }, 0);
      } catch (err) {
        console.error(err);
      }
    },

    methodDownloadCSVOne() {
      const fields = [
        {
          label: "Zone",
          value: "properties.zone"
        },
        {
          label: "Trail Name",
          value: "properties.trail_name"
        },
        {
          label: "Bridge Number",
          value: "properties.bridge_num"
        },
        {
          label: "Date Inspected",
          value: "properties.dt_inspect"
        },
        {
          label: "Inspector",
          value: "properties.inspector"
        },
        {
          label: "Date Built",
          value: "properties.dt_blt"
        },
        {
          label: "Max Load",
          value: "properties.max_load"
        },
        {
          label: "Foundation",
          value: "properties.foundation"
        },
        {
          label: "Cribbing",
          value: "properties.cribbing"
        },
        {
          label: "Sills",
          value: "properties.sills"
        },
        {
          label: "Sills Wood Type",
          value: "properties.s_wood_typ"
        },
        {
          label: "Stringers",
          value: "properties.stringers"
        },
        {
          label: "Stringers Wood Type",
          value: "properties.st_wood_ty"
        },
        {
          label: "Railing",
          value: "properties.railing"
        },
        {
          label: "Decking",
          value: "properties.decking"
        },
        {
          label: "Needs Vehicle Sign",
          value: "properties.need_v_sig"
        },
        {
          label: "Needs Number Sign",
          value: "properties.need_num_s"
        },
        {
          label: "Notes",
          value: "properties.notes"
        }
      ];
      const opts = { fields };

      try {
        const csv = parse(
          this.$store.state.mapLayers.bikepark.layers.bridges.geojson.features
            .sort((a, b) => {
              if (a.properties.trail_name < b.properties.trail_name) return -1;
              if (a.properties.trail_name > b.properties.trail_name) return 1;
              return 0;
            })
            .filter(
              i =>
                i.properties.foundation === 1 ||
                i.properties.cribbing === 1 ||
                i.properties.sills === 1 ||
                i.properties.stringers === 1 ||
                i.properties.railing === 1 ||
                i.properties.decking === 1
            ),
          opts
        );
        const blob = new Blob([csv], { type: "octet/stream" });
        const a = document.createElement("a");
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = "bikepark_bridges_1_only.csv";
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }, 0);
      } catch (err) {
        console.error(err);
      }
    },

    methodDownloadCSVOneAndTwo() {
      const fields = [
        {
          label: "Zone",
          value: "properties.zone"
        },
        {
          label: "Trail Name",
          value: "properties.trail_name"
        },
        {
          label: "Bridge Number",
          value: "properties.bridge_num"
        },
        {
          label: "Date Inspected",
          value: "properties.dt_inspect"
        },
        {
          label: "Inspector",
          value: "properties.inspector"
        },
        {
          label: "Date Built",
          value: "properties.dt_blt"
        },
        {
          label: "Max Load",
          value: "properties.max_load"
        },
        {
          label: "Foundation",
          value: "properties.foundation"
        },
        {
          label: "Cribbing",
          value: "properties.cribbing"
        },
        {
          label: "Sills",
          value: "properties.sills"
        },
        {
          label: "Sills Wood Type",
          value: "properties.s_wood_typ"
        },
        {
          label: "Stringers",
          value: "properties.stringers"
        },
        {
          label: "Stringers Wood Type",
          value: "properties.st_wood_ty"
        },
        {
          label: "Railing",
          value: "properties.railing"
        },
        {
          label: "Decking",
          value: "properties.decking"
        },
        {
          label: "Needs Vehicle Sign",
          value: "properties.need_v_sig"
        },
        {
          label: "Needs Number Sign",
          value: "properties.need_num_s"
        },
        {
          label: "Notes",
          value: "properties.notes"
        }
      ];
      const opts = { fields };

      try {
        const csv = parse(
          this.$store.state.mapLayers.bikepark.layers.bridges.geojson.features
            .sort((a, b) => {
              if (a.properties.trail_name < b.properties.trail_name) return -1;
              if (a.properties.trail_name > b.properties.trail_name) return 1;
              return 0;
            })
            .filter(
              i =>
                i.properties.foundation === 1 ||
                i.properties.cribbing === 1 ||
                i.properties.sills === 1 ||
                i.properties.stringers === 1 ||
                i.properties.railing === 1 ||
                i.properties.decking === 1 ||
                i.properties.foundation === 2 ||
                i.properties.cribbing === 2 ||
                i.properties.sills === 2 ||
                i.properties.stringers === 2 ||
                i.properties.railing === 2 ||
                i.properties.decking === 2
            ),
          opts
        );
        const blob = new Blob([csv], { type: "octet/stream" });
        const a = document.createElement("a");
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = "bikepark_bridges_1_or_2.csv";
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }, 0);
      } catch (err) {
        console.error(err);
      }
    },

    pgDate(date) {
      function zeroPad(d) {
        return ("0" + d).slice(-2);
      }

      var parsed = new Date(date);

      return [
        parsed.getUTCFullYear() +
          "-" +
          zeroPad(parsed.getMonth() + 1) +
          "-" +
          zeroPad(parsed.getDate()) +
          " " +
          zeroPad(parsed.getHours()) +
          ":" +
          zeroPad(parsed.getMinutes()) +
          ":" +
          zeroPad(parsed.getSeconds())
      ].join(" ");
    },
    setOutput(file) {
      this.base64image = file;
    },
    geoSuccess(position) {
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
      this.accuracy = position.coords.accuracy;
      this.altitude = position.coords.altitude;
    },
    geoError() {
      console.log("geo error");
    },
    geoWatchPosition() {
      let geoOptions = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      };
      this.tracking = true;
      this.watchId = navigator.geolocation.watchPosition(
        this.geoSuccess,
        this.geoError,
        geoOptions
      );
    },
    clearWatchLocation() {
      navigator.geolocation.clearWatch(this.watchId);
      this.tracking = false;
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      if (utcdate !== null) {
        return y + "-" + m + "-" + d;
      } else {
        return;
      }
    },
    // method to get geojson
    methodGetBikeparkBridgesGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/bikepark/bridges",
        dept: "bikepark",
        layer: "bridges",
        token: this.computedAuthToken
      });
    },
    methodAddBikeparkBridgesGeoJson(data) {
      let constFeature = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "MultiPoint",
              coordinates: [[data.lng, data.lat]]
            },
            properties: {
              zone: data.zone,
              trail_name: data.trail_name,
              bridge_num: data.bridge_num,
              dt_inspect: data.dt_inspect,
              inspector: data.inspector,
              dt_blt: data.dt_blt,
              max_load: data.max_load,
              foundation: data.foundation,
              cribbing: data.cribbing,
              sills: data.sills,
              s_wood_typ: data.s_wood_typ,
              stringers: data.stringers,
              st_wood_ty: data.st_wood_ty,
              railings: data.railings,
              decking: data.decking,
              need_v_sig: data.need_v_sig,
              need_num_s: data.need_num_s,
              notes: data.notes
            }
          }
        ]
      };
      this.$store
        .dispatch("actionAddJsonImage", {
          url: "https://api2.alchemymapping.com/vail/whistler/bikepark/bridges",
          imageUrl:
            "https://api2.alchemymapping.com/vail/whistler/bikepark/bridges/image",
          base64data: this.base64image,
          dept: "bikepark",
          layer: "bridges",
          token: this.computedAuthToken,
          payload: constFeature
        })
        .then(
          setTimeout(() => {
            this.methodGetBikeparkBridgesGeoJson();
          }, 250)
        );
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.bikepark.layers.bridges.visibility.listView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetBikeparkBridgesGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.bikepark.layers.bridges.geojson": function(
      newValue
    ) {
      if (
        newValue &&
        this.$store.state.mapLayers.bikepark.layers.bridges.geojson
      ) {
        this.loading = false;
      }
    }
  }
};
</script>
